import { __awaiter } from "tslib";
import { Box3 } from "three";
import { computeBoundingBoxHelper } from "./vessel3D/vessels/helpers/computeBoundingBoxHelper";
import { fitCameraToBoundingBox } from "./fitCameraToBoundingBox";
export function fitCameraToMainScene(_a) {
    return __awaiter(this, arguments, void 0, function* ({ camera, object, offset, width, height, initialY, smooth, setCameraInPositionAndTarget, }) {
        if (!object) {
            console.warn("Object is not a group or is undefined");
            return;
        }
        const sg = object.getObjectByName("SingleGeometryMesh");
        if (!sg) {
            return;
        }
        const sgBoundingBox = computeBoundingBoxHelper(sg);
        if (!sgBoundingBox) {
            console.warn("SG bounding box is not defined");
            return;
        }
        const boundingBox = sgBoundingBox.box;
        const cg = object.getObjectByName("containers-group");
        if (cg) {
            const cgBoundingBox = new Box3();
            cgBoundingBox.setFromObject(cg);
            boundingBox.union(cgBoundingBox);
        }
        yield fitCameraToBoundingBox({
            camera,
            boundingBox,
            offset,
            width,
            height,
            initialY: initialY !== null && initialY !== void 0 ? initialY : (boundingBox.max.y + boundingBox.min.y) / 2,
            smooth,
            setCameraInPositionAndTarget,
        });
    });
}
